<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<button
	class="log-card__header"
	tuiButton
	appearance="ghost"
	(click)="onToggleCollapsed()"
>
	<ctx-log-thumbnail [log]="currentLog()!" size="l" />

	<div class="log-card__header-information">
		@if (currentLog()!.name; as name) {
			<h2 class="m-0" [title]="name">{{ name }}</h2>
		}

		@if (currentLog()!.createdAt.toDate() | relativeTime; as createdAt) {
			<small class="margin-v-1" [title]="createdAt">
				{{ createdAt }}
			</small>
		}

		@if (currentLog()!.media.length) {
			@let mediaCountText =
				'log.media-#'
					| transloco: { count: currentLog()!.media.length };
			<small [title]="mediaCountText">
				{{ mediaCountText }}
			</small>
		}
	</div>

	<div class="log-card__header-actions">
		@if (isArchived()) {
			<span tuiBadge appearance="neutral" iconStart="@tui.archive">
				<span class="log-card__header-actions-badge-text">
					{{ 'content.archived' | transloco }}
				</span>
			</span>
		}

		@if (actionable() && menuItems().length) {
			@if ('mobile' | isDevice) {
				<button
					size="m"
					tuiIconButton
					appearance="ghost"
					(click)="onMenuOpen()"
					noPropagation
				>
					<tui-icon icon="@tui.ellipsis" />
				</button>
			} @else {
				<button
					size="m"
					tuiIconButton
					appearance="ghost"
					[tuiDropdown]="logDropdown"
					[(tuiDropdownOpen)]="menuOpen"
					noPropagation
				>
					<tui-icon icon="@tui.ellipsis" />
				</button>
			}
		}

		<tui-icon [class.rotate]="!collapsed()" icon="@tui.chevron-down" />
	</div>
</button>

@if (!collapsed()) {
	<section class="log-card__content">
		@if (loading()) {
			<tui-loader size="xl" />
		} @else {
			@if (currentAccess() !== 'view') {
				@if (author(); as author) {
					<label>
						<p class="font-bold mt-0 mb-1">
							{{ 'content.owner' | transloco }}
						</p>

						<div class="log-card__content-author mb-3">
							<ctx-avatar [user]="author" />
							<p>{{ author | userName }}</p>
						</div>
					</label>
				}
			}

			<label>
				<p class="mt-0 mb-1 font-bold">
					{{ 'log.log-name' | transloco }}
				</p>
				<p class="mt-1 mb-3">
					{{ currentLog()!.name }}
				</p>
			</label>

			<label>
				<p class="mt-0 mb-1 font-bold">
					{{ 'data.created-at' | transloco }}
				</p>
				<p class="mt-1 mb-3">
					{{
						currentLog()!.createdAt.toDate()
							| date: 'MM/dd/yyyy hh:mm aa'
					}}
				</p>
			</label>

			@if (currentLog()!.description; as description) {
				<label>
					<p class="mt-0 mb-1 font-bold">
						{{ 'data.description' | transloco }}
					</p>
					<p class="mt-1 mb-3">
						{{ description }}
					</p>
				</label>
			}

			@if (media().length) {
				<div class="log-card__content-media" tuiCarouselButtons>
					<label>
						<p class="mt-0 mb-2 font-bold">
							{{ 'data.media' | transloco }}
						</p>

						<div class="log-card__content-media-carousel">
							@if (media().length > 1) {
								<button
									iconStart="@tui.chevron-left"
									tuiIconButton
									type="button"
									(click)="carousel.prev()"
									appearance="ghost"
								>
									{{ 'action.previous' | transloco }}
								</button>
							}

							<tui-carousel #carousel class="carousel">
								@for (item of media(); track item.id) {
									<div
										*tuiItem
										class="log-card__content-media-item"
									>
										<div
											class="log-card__content-media-item-information"
										>
											<ctx-media-thumbnail
												[media]="item"
											/>

											<p>{{ item.name }}</p>

											<button
												tuiIconButton
												iconStart="@tui.eye"
												appearance="ghost"
												(click)="onView(item)"
											>
												{{ 'action.view' | transloco }}
											</button>
										</div>
									</div>
								}
							</tui-carousel>

							@if (media().length > 1) {
								<button
									iconStart="@tui.chevron-right"
									tuiIconButton
									type="button"
									(click)="carousel.next()"
									appearance="ghost"
								>
									{{ 'action.next' | transloco }}
								</button>
							}
						</div>
					</label>
				</div>
			}
		}
	</section>
}

<ng-template #logDropdown>
	<ctx-detail-menu-dropdown [menuItems]="menuItems()" />
</ng-template>
